import { create } from "zustand";
import { DeliveryAddress, DrugPaymentData, DrugPaymentState } from "../types";

// Default delivery options
export const defaultDeliveryOptions = [
  {
    id: "pickup",
    name: "Pick up",
    description: "Pick up your medication physically at your preferred pharmacy.",
    price: 0,
  },
  {
    id: "delivery",
    name: "Delivery",
    description: "Enjoy the convenience of having your drugs delivered to you.",
    price: 2500.00, // todo: update default delivery fee to match BE
  },
];

export const useDrugPaymentStore = create<DrugPaymentState>((set, get) => ({
  paymentData: null,
  selectedDeliveryOption: "pickup", // Default to pickup
  deliveryAddress: null,
  error: null,

  setSelectedDeliveryOption: (optionId: string) => {
    set({ selectedDeliveryOption: optionId });
  },

  setDeliveryAddress: (address: DeliveryAddress) => {
    set({ deliveryAddress: address });
  },

  setPaymentData: (updater: (currentData: DrugPaymentData | null) => DrugPaymentData | null) => {
    const { paymentData } = get();
    const updatedData = updater(paymentData);
    set({
      paymentData: updatedData,
      error: null
    });
  },

  setError: (errorMessage: string | null) => {
    set({ error: errorMessage });
  },

  // update delivery fee for the delivery option
  updateDeliveryFee: (deliveryFee: number) => {
    const { paymentData } = get();
    if (!paymentData) return;

    const updatedDeliveryOptions = paymentData.deliveryOptions.map(option => {
      if (option.id === "delivery") {
        return { ...option, price: deliveryFee };
      }
      return option;
    });

    set({
      paymentData: {
        ...paymentData,
        deliveryOptions: updatedDeliveryOptions
      }
    });
  },

  removeItem: (itemId: string) => {
    const { paymentData } = get();
    if (!paymentData) return;

    const updatedDrugs = paymentData.drugs.filter(drug => drug._id !== itemId);

    set({
      paymentData: {
        ...paymentData,
        drugs: updatedDrugs
      }
    });
  }
}));


